import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import _findindex from 'lodash.findindex'
import gsap from 'gsap'
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// gsap.registerPlugin(ScrollTrigger);

// import { SplitText } from 'gsap/SplitText.js'
// import { log } from 'handlebars';
// gsap.registerPlugin(SplitText);


class Imagery extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = -1
    this.galleryEnabled = false;
    this.id = 0






//this.obj = JSON.parse(images);
//console.log(this.obj.length);

    this.ref = {
      next: null,
      prev: null,
      close: null,
      image: null, 
      artist: null, 
      photographer: null,
      img: [],
      container: null
    }

  }

  mount() {
    //this.transform()


    _each(this.ref.img, (item)=>{
      item.addEventListener('click', (e) => {

        e.preventDefault()
        const src = item.dataset.big
        const artist = item.dataset.artist
        const photographer = item.dataset.photographer
        const format = item.dataset.format


        this.addGallery(src, artist, photographer, format);
        this.id = $(e.currentTarget).index();
        
        
      })

    })

    
    $(this.ref.close).on('click', (e)=>{
      e.preventDefault()
      this.close()
    })
    $(this.ref.next).on('click', (e) => {
      e.preventDefault()
      this.next(1)
    })
    $(this.ref.prev).on('click', (e) => {
      e.preventDefault()
      this.next(-1)
    })

    this.sources = gsap.utils.toArray($('.img'))
   
 }

 addGallery(src, artist, photographer, format){

  

    if(!this.galleryEnabled) {

      //showGallery
      this.body.addClass('has-gallery')
      this.ref.image.src = src
      this.ref.container.dataset.full = format || 0
      this.galleryEnabled = true;
    }

    else {
      this.ref.image.src = ""
      this.ref.image.src = src
      

      this.ref.container.dataset.full = format || 0
    }


    this.ref.artist.innerHTML = artist
    this.ref.photographer.innerHTML = photographer


    
 }

 transform(){
  let increment = 1
  const all = []
  _each(this.obj , (item) => {

    console.log(item.artistphoto);
    

    const it = {
      "_id": `${increment++}`,
      "_type": "archiveImage",
      "artist": item.artistphoto.artist || "",
      "photographer": item.artistphoto.photographer || "",
      "tags": item.tags,
      "image": {
        "_type": "image",
        "_sanityAsset": `image@file:///Users/doru/W-Work/beatsanity/${item.image}`,
      }
    }

    all.push(it)
  })

  //console.log(JSON.stringify(all));
 }

 next(dir){
    const img = this.getSrc(dir)
    const item = img[1]
    const src = img[0]
    const artist = item.dataset.artist
    const photographer = item.dataset.photographer
    const format = item.dataset.format
    
    this.addGallery(src, artist, photographer, format)

 }

 getSrc(dir){

   const index = gsap.utils.wrap(0, this.ref.img.length, this.id + dir)
  
 
   var img =  this.ref.img[index]
   var src = img.dataset.big
   this.id = index

   return [src, img]
 }

 close(){
  this.galleryEnabled = false;
  this.body.removeClass('has-gallery')
 }


  unmount() {




  }


}

module.exports = Imagery
